import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { hideModal } from '../../actions/modal'
import { updatePoolThresholds, UPDATE_POOL_THRESHOLDS } from '../../actions/poolThresholds'
import ModalComponent from '../../components/modal/index'
import PropTypes from 'prop-types'
import { Button, Input, Label, FormGroup, InputGroup, InputGroupAddon } from 'reactstrap'

export class UpdatePoolThresholdsModal extends React.Component {

  constructor() {
    super()
    this.updatePoolThresholds = this.updatePoolThresholds.bind(this)
    this.onOpened = this.onOpened.bind(this)
    this.state = {
      isUpdatePoolThresholdsButtonDisabled: false,
      offlineValue: 0,
      onlineValue: 0,
    }
  }

  isPoolThresholdsValid(value) {
    const valueNumber = Number(value)
    return Math.sign(valueNumber) === 1 && Number.isInteger(valueNumber) && valueNumber < 1440
  }

  isUpdateDisabled(offlineValue, onlineValue) {
    const isOfflineValid = this.isPoolThresholdsValid(offlineValue)
    const isOnlineValid = this.isPoolThresholdsValid(onlineValue)

    if (!isOfflineValid || !isOnlineValid) {
      return true
    }

    if (this.props.isDefault === true) {
      return Number(offlineValue) === this.props.offlineThreshold && Number(onlineValue) === this.props.onlineThreshold
    }

    return false
  }

  updatePoolThresholds() {
    if (this.isUpdateDisabled(this.state.offlineValue, this.state.onlineValue)) {
      return
    }

    const thresholdObject = {
      offlineThreshold: this.state.offlineValue,
      onlineThreshold: this.state.onlineValue
    };
    
    this.props.updatePoolThresholds(this.props.poolId, 
      thresholdObject, 
      true, 
      this.props.partnerId,
      this.props.partnerSubscriptionId)
  }


  offlineValueChanged(newValue) {
    this.setState((prevState) => ({
      isUpdatePoolThresholdsButtonDisabled: this.isUpdateDisabled(newValue, prevState.onlineValue),
      offlineValue: newValue,
    }))
  }

  onlineValueChanged(newValue) {
    this.setState((prevState) => ({
      isUpdatePoolThresholdsButtonDisabled: this.isUpdateDisabled(prevState.offlineValue, newValue),
      onlineValue: newValue,
    }))
  }

  resetToDefault() {
    this.props.updatePoolThresholds(this.props.poolId,
      null,
      false,
      this.props.partnerId,
      this.props.partnerSubscriptionId)
  }

  onOpened() {
    if (this.props.offlineThreshold != null && this.props.onlineThreshold != null) {
      this.setState({
        isUpdatePoolThresholdsButtonDisabled: this.isUpdateDisabled(this.props.offlineThreshold, this.props.onlineThreshold),
        offlineValue: this.props.offlineThreshold,
        onlineValue: this.props.onlineThreshold,
      })
    }
  }

  render() {
    if (this.props.isOpen && this.props.modalType === UPDATE_POOL_THRESHOLDS) {

      const body = <FormGroup>
        <Label>Enter new Pool thresholds</Label>
        <br/><br/>
        <Label for="offlineValue">Offline threshold</Label>
        <InputGroup>
          <Input type="number" step="1" id="OfflineValue" onChange={(e) => this.offlineValueChanged(e.target.value)} value={this.state.offlineValue} />
          <InputGroupAddon addonType="append">minutes</InputGroupAddon>
        </InputGroup>
        <br/>
        <Label for="onlineValue">Online threshold</Label>
        <InputGroup>
          <Input type="number" step="1" id="onlineValue" onChange={(e) => this.onlineValueChanged(e.target.value)} value={this.state.onlineValue} />
          <InputGroupAddon addonType="append">minutes</InputGroupAddon>
        </InputGroup>
        <Button color="link" onClick={() => this.resetToDefault()}>Reset to default</Button>
      </FormGroup>

      const primaryButton = <Button color="primary" id="UpdatePoolThresholdsButton" onClick={this.updatePoolThresholds} disabled={this.state.isUpdatePoolThresholdsButtonDisabled}>Update</Button>

      return <ModalComponent
        isOpen={this.props.isOpen}
        body={body}
        toggle={this.props.hideModal}
        primaryButton={primaryButton}
        onOpened={this.onOpened} />
    }

    return null
  }
}

const mapStateToProps = state => {
  return {
    isOpen: state.modal.isOpen,
    modalType: state.modal.modalType,
    poolId: state.poolDetails.id,
    partnerSubscriptionId: state.poolDetails.partnerSubscriptionId,
    partnerId: state.poolDetails.partnerId,
    isDefault: state.poolDetails.poolSummary.isDefault,
    offlineThreshold: state.poolDetails.poolSummary.offlineThreshold,
    onlineThreshold: state.poolDetails.poolSummary.onlineThreshold
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  hideModal,
  updatePoolThresholds
}, dispatch)

UpdatePoolThresholdsModal.propTypes = {
  isOpen: PropTypes.bool,
  modalType: PropTypes.string,
  poolId: PropTypes.string,
  partnerSubscriptionId: PropTypes.string,
  partnerId: PropTypes.string,
  hideModal: PropTypes.func,
  isDefault: PropTypes.bool,
  offlineThreshold: PropTypes.number,
  onlineThreshold: PropTypes.number,
  updatePoolThresholds: PropTypes.func
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdatePoolThresholdsModal)



// WEBPACK FOOTER //
// ./src/containers/modal/updatePoolThresholds.js